export { default } from './SkeletonHeroMonthlyHistogram';
